import * as React from 'react'
import { Link } from 'react-router'
import { styles } from './styles.css'

type Props = {
  to: string
  className?: string
  children: React.ReactNode
}

export const TextLink: React.FC<Props> = ({ children, to, className, ...rest }) => {
  return (
    <Link to={to} className={`${styles.link} ${className}`} {...rest}>
      {children}
    </Link>
  )
}
